import { omitKeys } from '@wix/funnel-utils';
export const back = _ref => {
  let {
    flowContext,
    updateFlowContext,
    questionKeysOnPagesRef
  } = _ref;
  const {
    historyEntries,
    answers
  } = flowContext;
  if (historyEntries.length < 3) {
    console.error('[Lizard] cannot go back when there is less than 3 history entries:', historyEntries);
    return;
  }
  const questionKeysOnPages = questionKeysOnPagesRef.current;
  const previousPageId = historyEntries[historyEntries.length - 2].pageId;
  const previousPageQuestionKeys = questionKeysOnPages[previousPageId];
  updateFlowContext({
    ...flowContext,
    historyEntries: historyEntries.slice(0, -1),
    answers: omitKeys(answers, previousPageQuestionKeys)
  });
  questionKeysOnPagesRef.current = omitKeys(questionKeysOnPages, [previousPageId]);
};
//# sourceMappingURL=back.js.map